import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PromoService {

  constructor(
    private http: HttpClient
  ) { }

  riscattaCodicePromo(idVisita: number, codiceForm: string, codicePromo: string): Observable<any> {
    return this.http.get(
      environment.apiUrl + 'public/riscattaCodicePromo/null/' + idVisita + '/' + codiceForm + '/' + codicePromo + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getDettaglioPromoCantinaLibera($id, codiceForm): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + 'public/promo/cantinalibera/' + $id + '/' + codiceForm + '/')
      .pipe(
        map(response => {
          return response;
        }));
  }

  controllaPromo(promodacontrollare, nposti, costoTotale, costoSingolo, codice) {
    const ritorno = {
      risultato: false,
      // tslint:disable-next-line:object-literal-shorthand
      codice: codice,
      valore: 0,
      label: '',
      errore: '',
      data1: '',
      data2: '',
      promo: promodacontrollare,
      codice_required: '1'
    };
    let datainizio = null;
    let datascadenza = null;
    const tipo = promodacontrollare.tipo;
    const isScad = promodacontrollare.scadenza === '0' ? false : true;
    const valore = parseFloat(promodacontrollare.valore);
    let datavalidaInizio = true;
    let datavalidaFine = true;
    let datavalida = true;

    if (true) {
      ritorno.codice_required = promodacontrollare['codice_required'];

      if (isScad) {
        const dataodierna = moment();

        if (promodacontrollare.datainizio) {
          datainizio = moment(promodacontrollare.datainizio);
          datavalidaInizio = datainizio.isSameOrBefore(dataodierna, 'day');
        }
        datascadenza = moment(promodacontrollare.datascadenza);
        datavalidaFine = datascadenza.isSameOrAfter(dataodierna, 'day');

        if (datavalidaInizio && datavalidaFine) {
          datavalida = true;
        } else {
          datavalida = false;
          if (datavalidaInizio === false) {
            ritorno.risultato = false;
            ritorno.errore = 'promodialogo.scadutarange';
            ritorno.data1 = datainizio;
            ritorno.data2 = datascadenza;
          } else {
            ritorno.risultato = false;
            ritorno.errore = 'promodialogo.scaduta';
          }
          ritorno.risultato = false;
        }
      }
    }
    if (datavalida) {
      const minimo = parseFloat(promodacontrollare.minimo);
      if (nposti > 0) {
        let valoresconto = 0;
        switch (tipo) {
          case '0':
            valoresconto = valore;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = '€ ' + valoresconto.toFixed(2);

            break;
          case '1':
            valoresconto = costoTotale / 100 * valore;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = valore + ' %';

            break;
          case '2':
            valoresconto = valore * nposti;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = '€ ' + valoresconto.toFixed(2);

            break;
          case '3':
            const maxticket = parseInt(promodacontrollare.maxticket, 10);
            if (maxticket > nposti) {
              valoresconto = costoTotale / 100 * valore;
            } else {
              valoresconto = (maxticket * costoSingolo) / 100 * valore;
            }
            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = '€ ' + valoresconto.toFixed(2);
            break;
          default:
            break;
        }
        if ((minimo !== 0 && costoTotale >= minimo) || minimo === 0) {
        } else {
          ritorno.risultato = false;
          ritorno.errore = 'promodialogo.importominimo';
        }
      } else {
      }
    }
    return ritorno;
  }

  controllaRegalo(promodacontrollare, nposti, costoTotale, costoSingolo, codice) {
    const ritorno = {
      risultato: false,
      // tslint:disable-next-line:object-literal-shorthand
      codice: codice,
      valore: 0,
      label: '',
      errore: '',
      data1: '',
      data2: '',
      promo: promodacontrollare
    };
    const npersone = promodacontrollare.npersone;
    const scadenza = promodacontrollare.datascadenza;

    if (nposti > 0) {

      const dataodierna = moment();
      const datascadenza = moment(scadenza);

      const datavalida = datascadenza.isSameOrAfter(dataodierna, 'day');

      if (datavalida) {
        ritorno.risultato = true;
        ritorno.valore = costoSingolo * npersone;
        ritorno.label = '€ ' + (costoSingolo * npersone).toFixed(2);
      } else {
        ritorno.risultato = false;
        ritorno.errore = 'promodialogo.scaduta';
      }
    } else {
    }

    return ritorno;
  }

  riscattaCodicePromoVino(idVino: number, codiceForm: string, codicePromo: string, isVino: boolean): Observable<any> {
    return this.http.get(
      environment.apiUrl + 'public/riscattaCodicePromoVino/null/' + idVino + '/' + codiceForm + '/' + codicePromo + '/' + isVino + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  controllaPromoVino(promodacontrollare, nposti, costoTotale, costoSingolo, codice) {
    const ritorno = {
      risultato: false,
      codice: codice,
      valore: 0,
      label: '',
      errore: '',
      data1: '',
      data2: '',
      promo: promodacontrollare
    };
    let datainizio = null;
    let datascadenza = null;
    const tipo = promodacontrollare['tipo'];
    const isScad = promodacontrollare['scadenza'] === '0' ? false : true;
    const valore = parseFloat(promodacontrollare['valore']);
    let datavalidaInizio = true;
    let datavalidaFine = true;
    let datavalida = true;

    // if (promodacontrollare['codicepromo'].length < 8) {
    if (true) {
      if (isScad) {
        const dataodierna = moment();

        if (promodacontrollare['datainizio']) {
          datainizio = moment(promodacontrollare['datainizio']);
          datavalidaInizio = datainizio.isSameOrBefore(dataodierna, 'day');
        }

        datascadenza = moment(promodacontrollare['datascadenza']);
        datavalidaFine = datascadenza.isSameOrAfter(dataodierna, 'day');

        if (datavalidaInizio && datavalidaFine) {
          datavalida = true;
        } else {
          datavalida = false;
          if (datavalidaInizio === false) {
            ritorno.risultato = false;
            ritorno.errore = 'promodialogo.scadutarange';
            ritorno.data1 = datainizio;
            ritorno.data2 = datascadenza;
          } else {
            ritorno.risultato = false;
            ritorno.errore = 'promodialogo.scaduta';
          }
          ritorno.risultato = false;
        }
      }
    }
    if (datavalida) {
      const minimo = parseFloat(promodacontrollare['minimo']);
      if (nposti > 0) {
        let valoresconto = 0;
        switch (tipo) {
          case '0':
            valoresconto = valore;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = '€ ' + valoresconto.toFixed(2);

            break;
          case '1':
            valoresconto = costoTotale / 100 * valore;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = valore + ' %';

            break;
          case '2':
            valoresconto = valore * nposti;

            ritorno.risultato = true;
            ritorno.valore = valoresconto;
            ritorno.label = '€ ' + valoresconto.toFixed(2);

            break;
        }
        if ((minimo !== 0 && costoTotale >= minimo) || minimo === 0) {
        } else {
          ritorno.risultato = false;
          ritorno.errore = 'promodialogo.importominimo';
        }
      } else {
      }
    }
    return ritorno;
  }
}
